var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15 5H1","stroke":"#52668C","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M19 1H1","stroke":"#52668C","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M19 9H1","stroke":"#52668C","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M15 13H1","stroke":"#52668C","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Burger.defaultProps = {"width":"20","height":"14","viewBox":"0 0 20 14","fill":"none"};

module.exports = Burger;

Burger.default = Burger;
